<template>
  <div class="wrapper">
    <div class="main-panel vap-fullscreen">

      <fullscreen-content></fullscreen-content>

      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>
<style lang="scss" scoped="">
.main-panel{
  width: 100%;
}
.main-panel.vap-fullscreen > .content{
  padding: 0;
  margin: 0;
}
</style>
<script>
  // import TopNavbar from './TopNavbar.vue'
  // import ContentFooter from './ContentFooter.vue'
  import FullscreenContent from './FullscreenContent.vue'
  export default {
    components: {
      // TopNavbar,
      // ContentFooter,
      FullscreenContent
    },
    props: [],
    methods: { },
    computed: { }
  }

</script>



// WEBPACK FOOTER //
// FullscreenLayout.vue?21c189f4